import React from 'react'
import TableItem from './tableItem'
import Calculator from './calculator'

const Table = ({ tables, price, permissibleValues, tabName, activeRowCol, claritySort }) => {
  return (
    <div className='price__content'>
      <ul className='price__tables'>
        {tables.map((table, index) => {
          return <TableItem key={index} table={table} tabName={tabName} activeRowCol={activeRowCol} claritySort={claritySort} />
        })}
      </ul>
      <Calculator price={price} permissibleValues={permissibleValues} />
    </div>
  )
}

export default Table
